var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPenNibStraight = function SvgIconPenNibStraight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.25 6.517V3a1.75 1.75 0 0 0-1.75-1.75h-9A1.75 1.75 0 0 0 5.75 3v3.517l-2.662 5.397a1 1 0 0 0 .101 1.048l8.009 10.51a1 1 0 0 0 1.604 0l8.009-10.51a1 1 0 0 0 .101-1.048zM7.75 5.75h8.5v-2.5h-8.5zM13 19.913l5.845-7.67-2.217-4.493H7.372l-2.217 4.493L11 19.913v-4.445a3.252 3.252 0 0 1 1-6.343 3.25 3.25 0 0 1 1 6.343zm-2.25-7.538a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconPenNibStraight;